import styled from 'styled-components';
export const UnderLine = styled.div `
  position: relative;
  width: 100%;
  &::before {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    content: ' ';
    border-bottom: 1px solid ${(props) => { var _a; return ((_a = props.theme) === null || _a === void 0 ? void 0 : _a.borderColor) || '#DBDBDB'; }};
  }
`;
